import { useRef, useEffect, useCallback } from 'react';

export const useAbortController = () => {
  const abortControllers = useRef(new Map());
  const isMountedRef = useRef(true);

  const getNewAbortSignal = useCallback((uniqueAPINameKey = 'default') => {
    if (abortControllers.current.has(uniqueAPINameKey)) {
      abortControllers.current.get(uniqueAPINameKey).abort();
    }
    const controller = new AbortController();
    abortControllers.current.set(uniqueAPINameKey, controller);
    return controller.signal;
  }, []);

  useEffect(() => {
    return () => {
      abortControllers.current.forEach((controller) => controller.abort());
      isMountedRef.current = false;
    };
  }, []);

  return { getNewAbortSignal, isMountedRef };
};
